/*
    Menu configuration file
    href: URL path
    titleKey: Translation key for the menu item title
    icon: Icon path for the menu item
    permission: Permission code required to access the menu item
 */
export const menu = [
  {
    href: "/",
    titleKey: "dashboard",
    icon: "images/desktop/icons/brand-green/dashboard.svg",
    permission: "DASHBOARD",
  },
  {
    href: "/tools/ai-chat",
    titleKey: "ai_assistant.title",
    icon: "images/desktop/icons/brand-green/ai-assistant.svg",
    permission: "AI_CHAT",
    child: [
      {
        href: "/tools/ai-chat",
        titleKey: "ai_assistant.title",
        permission: "AI_CHAT",
      },
      {
        href: "/tools/ai-chat-settings",
        titleKey: "ai_assistant.settings_title",
        permission: "SETTINGS",
        needSuperAdmin: true,
      },
    ],
  },
  {
    href: "/works/cultures",
    titleKey: "common.works",
    icon: "images/desktop/icons/brand-green/works.svg",
    child: [
      {
        href: "/works/cultures",
        titleKey: "works.cultures.name",
        permission: "PARCELS",
      },
      {
        href: "/works/parcels",
        titleKey: "common.parcels",
        permission: "PARCELS",
      },
      {
        href: "/works/parcel-management",
        titleKey: "works.parcel_management.name",
        permission: "PARCEL_MANAGEMENT",
      },
      {
        href: "/works/persons",
        titleKey: "works.persons.name",
        permission: "PERSONS",
      },
      {
        href: "/works/inputs",
        titleKey: "works.inputs.name",
        permission: "WORK_MACHINES",
      },
      {
        href: "/works/seasons",
        titleKey: "works.seasons.name",
        permission: "PARCELS",
      },
      {
        href: "/works/work-group-list",
        titleKey: "works.work_group_list.name",
        permission: "WORK_GROUPS",
      },
      {
        href: "/works/work-list",
        titleKey: "common.work_list",
        permission: "WORKS",
      },
      {
        href: "/works/work-approval",
        titleKey: "works.work_approval.name",
        permission: "WORK_APPROVAL",
        setting: "ENABLE_WORK_CONSUMPTION_AND_PRODUCTION_APPROVAL",
      },
      {
        href: "/works/applyArticles?showMapp=true",
        titleKey: "map.title",
        permission: "DIGITAL_AGENDA",
      },
      {
        href: "/works/applyArticles",
        titleKey: "digital_agenda.title",
        permission: "DIGITAL_AGENDA",
      },
    ],
  },
  {
    href: "/works/work-machines",
    titleKey: "works.work_machines.equipment",
    icon: "images/desktop/icons/brand-green/utilaj.svg",
    permission: "WORK_MACHINES",
    child: [
      {
        href: "/works/work-machines",
        titleKey: "works.work_machines.name",
        permission: "WORK_MACHINES",
      },
    ]
  },
  {
    href: "/stock-management/sm-products",
    titleKey: "stock_management.title",
    icon: "images/desktop/icons/brand-green/stock-management.svg",
    child: [
      {
        href: "/stock-management/sm-stocks",
        titleKey: "common.stock",
        permission: "SM_STOCK",
      },
      {
        href: "/stock-management/sm-products",
        titleKey: "common.products",
        permission: "SM_PRODUCTS",
      },
      {
        href: "/stock-management/sm-product-types",
        titleKey: "stock_management.product_types.title",
        permission: "SM_PRODUCTS",
      },
      {
        href: "/stock-management/sm-transactions",
        titleKey: "common.transactions",
        permission: "SM_TRANSACTIONS",
      },
      {
        href: "/stock-management/storage-losses",
        titleKey: "stock_management.storage_losses.title",
        permission: "SM_STORAGE_LOSSES",
      },
      /*{
        href: "/stock-management/sm-movements",
        titleKey: "common.movements",
        permission: "SM_MOVEMENTS",
      },*/
      {
        href: "/stock-management/sm-partners",
        titleKey: "common.partners",
        permission: "SM_PARTNERS",
      },
      {
        href: "/stock-management/sm-warehouses",
        titleKey: "common.warehouses",
        permission: "SM_WAREHOUSES",
      },
      {
        href: "/tools/measure-units",
        titleKey: "tools.measure_units.title",
        permission: "SETTINGS",
      },
      {
        href: "/stock-management/contracts-purchase-sale",
        titleKey: "common.contracts",
        permission: "SM_CONTRACTS_PURCHASE_SALE",
      },
      {
        href: "/stock-management/orders",
        titleKey: "stock_management.orders.title",
        permission: "SM_ORDERS",
      },
      {
        href: "/stock-management/invoice-management",
        titleKey: "stock_management.invoice_management.title",
        permission: "SM_INVOICE_MANAGEMENT",
      },
      {
        href: "/stock-management/predefined-lot-numbers",
        titleKey: "stock_management.predefined_lot_numbers.title",
        permission: "SM_PREDEFINED_LOT_NUMBER",
        setting: "USE_PREDEFINED_LOT_NUMBER",
      },
      {
        href: "/stock-mobile",
        titleKey: "stock_mobile.title",
        permission: "STOCK_MANAGEMENT",
      },
    ],
  },
  {
    href: "",
    titleKey: "common.scale",
    icon: "images/desktop/icons/brand-green/scale.svg",
    child: [
      {
        href: "/scale/scale-houses",
        titleKey: "scale.scale_houses.title",
        permission: "SCALE_HOUSES",
      },
      {
        href: "/scale/scales",
        titleKey: "scale.scales.title",
        permission: "SCALES",
      },
      {
        href: "/scale/weighing-on-scale",
        titleKey: "scale.weighing_on_scale.title",
        permission: "WEIGHING_ON_SCALE",
      },
      {
        href: "/scale/quantity-warnings",
        titleKey: "scale.quantity_warnings.title",
        permission: "QUANTITY_WARNINGS",
      },
      {
        href: "/field-report-mobile",
        titleKey: "common.field_report",
        permission: "FIELD_REPORT",
      },
    ],
  },
  {
    href: "",
    titleKey: "scouting.title",
    icon: "images/desktop/icons/brand-green/scouting.svg",
    child: [
      {
        href: "/scouting/admin",
        titleKey: "scouting.scouting_report",
        permission: "SCOUTINGS",
      },
    ],
  },
  {
    href: "",
    titleKey: "reporting.title",
    icon: "images/desktop/icons/brand-green/report.svg",
    child: [
      {
        href: "/reporting/report-list",
        titleKey: "common.reports",
        permission: "REPORTS",
      },
      {
        href: "/reporting/management-board",
        titleKey: "reporting.management_board.title",
        permission: "MANAGEMENT_BOARD",
      },
      {
        href: "/reporting/report-groups",
        titleKey: "reporting.groups.menu",
        permission: "REPORT_GROUPS",
        needSuperAdmin: true,
      },
      {
        href: "/reporting/report-management",
        titleKey: "reporting.management.menu",
        permission: "REPORTS",
        needSuperAdmin: true,
      },
    ],
  },
  {
    href: "",
    titleKey: "common.arenda",
    icon: "images/desktop/icons/brand-green/field-contract-management.svg",
    child: [
      {
        href: "/arenda-management/contracts",
        titleKey: "common.contracts",
        permission: "ARENDA_CONTRACTS_ADMIN",
      },
      {
        href: "/arenda-management/products",
        titleKey: "arenda_management.products",
        permission: "ARENDA_PRODUCTS_ADMIN",
      },
      {
        href: "/arenda-management/product-prices",
        titleKey: "arenda_management.product-prices",
        permission: "ARENDA_PRICES_ADMIN",
      },
      {
        href: "/arenda-management/tariff-systems",
        titleKey: "arenda_management.tariff-systems",
        permission: "ARENDA_TARIF_ADMIN",
      },
      {
        href: "/rent",
        titleKey: "common.arenda",
        permission: "ARENDA",
      },
    ],
  },
  {
    href: "/salary-calculator/sc-work-log",
    titleKey: "common.salary_calculator",
    icon: "images/desktop/icons/brand-green/salary-calculator.svg",
    child: [
      {
        href: "/salary-calculator/sc-holiday",
        titleKey: "salary_calculator.holiday.days",
        permission: "SC_BONUS",
      },
      {
        href: "/salary-calculator/sc-bonus",
        titleKey: "salary_calculator.bonus.title",
        permission: "SC_BONUS",
      },
      {
        href: "/salary-calculator/sc-employee-role",
        titleKey: "salary_calculator.employee_role.title",
        permission: "SC_EMPLOYEE_ROLE",
      },
      {
        href: "/salary-calculator/sc-employee",
        titleKey: "salary_calculator.employee.title",
        permission: "SC_EMPLOYEE",
      },
      {
        href: "/salary-calculator/sc-measure-unit",
        titleKey: "common.measure_unit",
        permission: "SC_MEASURE_UNIT",
      },
      {
        href: "/salary-calculator/sc-shift",
        titleKey: "common.shift",
        permission: "SC_SHIFT",
      },
      {
        href: "/salary-calculator/sc-work-group",
        titleKey: "common.work_group",
        permission: "SC_WORK_GROUP",
      },
      {
        href: "/salary-calculator/sc-work-type",
        titleKey: "common.work_type",
        permission: "SC_WORK",
      },
      {
        href: "/salary-calculator/sc-work",
        titleKey: "salary_calculator.work.title",
        permission: "SC_WORK",
      },
      {
        href: "/salary-calculator/sc-work-log",
        titleKey: "salary_calculator.work_log.title",
        permission: "SC_WORK_LOG",
      },
      {
        href: "/salary-calculator/reports",
        titleKey: "common.reports",
        permission: "SC_REPORTS",
      },
    ],
  },
  {
    href: "",
    titleKey: "apia.title",
    icon: "images/desktop/icons/brand-green/apia.svg",
    child: [
      {
        href: "/apia/fertilization-plan",
        titleKey: "apia.fertilization_plan",
        permission: "APIA",
      },
      {
        href: "/apia/phytosanitary-register",
        titleKey: "apia.phytosanitary_register.title",
        permission: "APIA",
      },
      {
        href: "/apia/farm-register",
        titleKey: "apia.farm_register",
        permission: "APIA",
      },
    ],
  },
  {
    href: "",
    titleKey: "products_catalog.title",
    icon: "images/desktop/icons/brand-green/stock-management.svg",
    child: [
      {
        href: "/products-catalog/fito-products",
        titleKey: "products_catalog.fito_products.title",
        permission: "ARENDA_CONTRACTS_ADMIN",
      },
      {
        href: "/products-catalog/fertility-products",
        titleKey: "products_catalog.fertility_products.title",
        permission: "ARENDA_CONTRACTS_ADMIN",
      },
      /*{
        href: "/",
        titleKey: "products_catalog.calculator",
        permission: "ARENDA_CONTRACTS_ADMIN",
      },*/
    ],
  },
  {
    href: "/users",
    titleKey: "security.name",
    icon: "images/desktop/icons/brand-green/security.svg",
    child: [
      {
        href: "/users",
        titleKey: "user_management",
        permission: "USER_MANAGEMENT",
      },
      {
        href: "/roles-permissions",
        titleKey: "roles_permissions",
        permission: "ROLES_PERMISSIONS",
      },
       {
        href: "/security/activity-logs",
        titleKey: "security.activity_logs.title",
        permission: "ACCESS_ACTIVITY_LOGS",
      },
      {
        href: "/security/user-analytics",
        titleKey: "security.user_analytics.title",
        permission: "USER_ANALYTICS",
      },
    ],
  },
  {
    href: "/tools/configurator",
    titleKey: "tools.name",
    icon: "images/desktop/icons/brand-green/tools.svg",
    child: [
      {
        href: "/tools/import",
        titleKey: "import",
        permission: "IMPORT",
      },
      {
        href: "/tools/configurator",
        titleKey: "import_configurator",
        permission: "CONFIGURATOR",
      },
      {
        href: "/tools/validated-data-special-cases",
        titleKey: "tools.special_cases.title",
        permission: "VALIDATED_DATA_SPECIAL_CASES",
      },
      {
        href: "/tools/justifying-documents",
        titleKey: "tools.justifying_documents.title",
        permission: "JUSTIFYING_DOCUMENTS",
      },
      {
        href: "/tools/settings",
        titleKey: "common.settings",
        permission: "SETTINGS",
      },
      {
        href: "/tools/label-management",
        titleKey: "tools.label_management.title",
        permission: "LABEL_MANAGEMENT",
      },
      {
        href: "/tools/erp-integration",
        titleKey: "tools.erp_integration.title",
        permission: "ERP_INTEGRATION",
        needSuperAdmin: true,
      },

    ],
  },
];
